import styled from "styled-components";

const TitlePageContainer = styled.div`
  font-size: 20px;
  font-weight: 400;
`;

export { TitlePageContainer };
